import { useContext } from 'react';
import { SyncContext, SyncContextValue } from '@/shared/components/SyncProvider';

export type { SyncContextValue };

export function useSyncStatus(): SyncContextValue {
  const ctx = useContext(SyncContext);
  if (!ctx) throw new Error('useSyncStatus must be used within SyncProvider');
  return ctx;
}
